import { useMemo } from 'react';

import type { CategoryTreeBuildDto } from '@/api/gen/_model/categoryTreeBuildDto';
import { useLocale } from '@/hooks/useLocale';
import { createSubjectNameGetter } from '@/shared/category/subject.util';

export const useCreateSubjectNameGetter = (
  filteredCategories: CategoryTreeBuildDto[] | undefined,
) => {
  const { locale } = useLocale();
  return useMemo(
    () => createSubjectNameGetter(filteredCategories ?? [], locale),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filteredCategories],
  );
};
